module.exports = __webpack_public_path__ + "static/media/zk-transfer-icon.c8c84378.svg";